export default class BtnSelect {

    constructor(element) {
        if(!element) {
            return;
        }

        this.elements = {
            holder: element
        }

        this.elements.items = this.elements.holder.querySelectorAll('.js-btn-select-item');
        this.elements.fieldset = this.elements.holder.querySelector('.js-btn-select-fieldset');

        this.multiple = (this.elements.holder.dataset.multiple == "true") ? true : false;
        this.isSet = false;
        this.currentSelected = false;

        if(!this.elements.items.length) {return;}

        this._setDOMReferences();
    }

    _setDOMReferences() {
        for (let i = 0; i < this.elements.items.length; i++) {
            const element = this.elements.items[i];
            element.addEventListener("click", () => this.onSelect(i, element));
        }
    }

    onSelect(index, button) {

        if(this.multiple) {
            if(this.currentSelected === false) {
                this.currentSelected = [];
            }

            if(this.currentSelected.indexOf(index) >= 0) {
                this.currentSelected.splice(this.currentSelected.indexOf(index), 1);
                button.classList.remove('is--selected');
            } else {
                this.currentSelected.push(index);
                button.classList.add('is--selected');
            }
        } else {
            if(this.isSet && index == this.currentSelected) {
                this.isSet = false;
                this.currentSelected = false;
            } else {
                this.isSet = true;
                this.currentSelected = index;
            }
        }

        if(this.elements.fieldset) {

            let inputs;

            if(this.multiple) {
                inputs = this.elements.fieldset.querySelectorAll('input[type="checkbox"]');

                for (let i = 0; i < inputs.length; i++) {
                    const element = inputs[i];
                    if(this.currentSelected.indexOf(i) >= 0) {
                        element.checked = true;
                    } else {
                        element.checked = false;
                    }
                }

                inputs[0].focus();
                inputs[0].blur();
            } else {
                inputs = this.elements.fieldset.querySelectorAll('input[type="radio"]');

                for (let i = 0; i < this.elements.items.length; i++) {
                    const element = this.elements.items[i];
                    element.classList.remove('is--selected');
                }

                if(this.currentSelected === false) {
                    inputs[index].focus();
                    inputs[index].checked = false;
                    inputs[index].blur();
                } else if(inputs[this.currentSelected]) {
                    inputs[this.currentSelected].focus();
                    inputs[this.currentSelected].checked = true;
                    inputs[this.currentSelected].blur();
                    button.classList.add('is--selected');
                }
            }
        }
    }

}